import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue';
import { SidebarIconName } from '../../constants/enums';
import DashboardIcon from './DashboardIcon.vue';
import TimelineIcon from './TimelineIcon.vue';
import PhotosIcon from './PhotosIcon.vue';
import DocumentsIcon from './DocumentsIcon.vue';
import WarrantyIcon from './WarrantyIcon.vue';
import MessagesIcon from './MessagesIcon.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String as PropType<SidebarIconName>,
    required: true,
    validation: (v) => Object.values(SidebarIconName).includes(v),
  },
},
  setup(__props) {

const props = __props

const icon = (() => {
  switch (props.name) {
    case SidebarIconName.dashboard:
      return DashboardIcon;

    case SidebarIconName.timeline:
      return TimelineIcon;

    case SidebarIconName.messages:
      return MessagesIcon;

    case SidebarIconName.photos:
      return PhotosIcon;

    case SidebarIconName.documents:
      return DocumentsIcon;

    case SidebarIconName.warranty:
      return WarrantyIcon;
    /* no default */
  }
})();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon))))
}
}

})